import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../reducers/form';
import * as api from '../../../api/list'
import validateProps from '../../../functions/validateProps'
import { enqueueSnackbar } from '../../../reducers/notifier'
import SimpleAdd from '../../../components/SimpleAdd'
import { machineStatus } from '../../../enum/machine-status.enum'


export default function MachineStateAdd({ history, match }) {
  const dispatch = useDispatch()
  const formName = 'MachineStateAdd'
  useEffect(() => {
    dispatch(actions.formInitialize({ typeState: '', startDate: '', endDate: '', comment: '', errorValidate: { name: false } }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  const arrProps = [
    { bp: { md: 12, sm: 12 }, field: 'typeState', type: 'autoArr', label: 'Статус', textProps: { arr: machineStatus } },
    { bp: { md: 6, sm: 12 }, field: 'startDate', type: 'text', label: 'Дата начала', textProps: { type: 'date' }, labelProps: { shrink: true }, },
    { bp: { md: 6, sm: 12 }, field: 'endDate', type: 'text', label: 'Дата окончания', textProps: { type: 'date' }, labelProps: { shrink: true }, },
    { bp: { md: 12, sm: 12 }, field: 'comment', type: 'text', label: 'Комментарий', textProps: { multiline: true, rows: "4" } },
  ]
  const handleSave = (e) => {
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: {
        typeState: values.typeState,
        startDate: values.startDate,
        endDate: values.endDate,
        comment: values.comment,
      },
      url: api.addMachineState.path({ id: match.params.id }),
      method: api.addMachineState.type,
      history: history
    }, formName))
  };
  return (
    <div className='App-paper'>
      <form autoComplete="off" onSubmit={handleSave}>
        <div style={{ padding: '16px' }}>
          <SimpleAdd
            arr={arrProps}
            formName={formName}
            title='Добавить статус'
            gridProps={{ xs: 12, xl: 9, lg: 10 }}
          />
        </div>
        <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        <Button type="submit" color="primary">Сохранить</Button>
      </form>
    </div>
  );
}
